import React from "react";
import Button from "@mui/material/Button";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import s from "./Header.module.scss";
import HeaderMenu from "./header-menu/HeaderMenu";
import useColors from "utils/useColors/useColors";

const Header = ({ sidebarHandling }) => {
  const c = useColors();
  const { isCollapse, handleSidebarCollapse } = sidebarHandling;

  return (
    <div className={s.headerContainer}>
      <div>
        {isCollapse && (
          <Button
            sx={{ minWidth: 32, maxWidth: 32, minHeight: 32, maxHeight: 32 }}
            className={s.collapseBtn}
            onClick={handleSidebarCollapse}
          >
            <MenuIcon sx={{ color: c.brandDark12 }} />
          </Button>
        )}
        {!isCollapse && (
          <Button
            sx={{ minWidth: 32, maxWidth: 32, minHeight: 32, maxHeight: 32 }}
            className={s.collapseBtn}
            onClick={handleSidebarCollapse}
          >
            <MenuOpenIcon sx={{ color: c.brandDark12 }} />
          </Button>
        )}
      </div>
      <div className={s.headerMenu}>
        <HeaderMenu />
      </div>
    </div>
  );
};

export default React.memo(Header);
